// 14-10-2026 (Jordy): videoduur in de content-kiezer.

/** Videoduur als m:ss (of u:mm:ss vanaf een uur). Leeg = nog niet gemeten. */
export function duurLabel(sec: number | null | undefined): string {
  if (sec == null || !Number.isFinite(sec) || sec <= 0) return ''
  const s = Math.round(sec)
  const u = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const r = String(s % 60).padStart(2, '0')
  return u > 0 ? `${u}:${String(m).padStart(2, '0')}:${r}` : `${m}:${r}`
}
